import { select, put } from 'redux-saga/effects';
import BillingHistoryActions from './BillingHistoryRedux';
import { AuthSelectors } from './AuthRedux';

import { transformClean } from '@services/transform';
import API from '@utils/api';
import logger from '@utils/logger';

export function* loadBillingHistory() {
  const state = yield select();
  const properties = yield select(AuthSelectors.selectUserProperties);

  try {
    const serviceTypeData = state.app.data.serviceTypes;
    const addonsData = state.app.data.addons;

    yield put(BillingHistoryActions.setBillingHistoryLoading(true));
    const { result } = yield API.getBillingHistory();
    const { bookings } = result;
    yield put(
      BillingHistoryActions.setBillingHistoryList(
        bookings.map(item =>
          transformClean(item, serviceTypeData, addonsData, properties)
        )
      )
    );
    yield put(BillingHistoryActions.setBillingHistoryLoading(false));
  } catch (err) {
    //TODO: notify error
    logger.error(err);
  }
}
